import AuthSetPasswordAPI from '@/app/apis/auth/auth-set-password/auth-set-password-api.js';

export default {
	/**
	 * @param {*} userDetails
	 */
	async postAuthSetPass(userDetails) {
		return AuthSetPasswordAPI.postAuthSetPass(userDetails);
	}
}